<template>
    <span class="label"
          data-component="MellonWebECRIntentStatusLabel"
          :class="color">
        {{ text }}
    </span>
</template>

<script>
import MellonWebECRIntentStatus from '@/lib/PaymentMethods/MellonWebECR/Enums/MellonWebECRIntentStatus';

export default {
    props: {
        /**
         * @type {MellonWebECRTransactionIntent}
         */
        intent: {
            type: Object,
            required: true,
        },
    },

    computed: {
        color() {
            if (this.intent?.Status) {
                if (this.intent.Status === MellonWebECRIntentStatus.COMPLETED) {
                    return 'label-success';
                }

                return 'label-warning';
            }

            return '';
        },

        text() {
            if (this.intent) {
                return Object.entries(MellonWebECRIntentStatus).find((entry) => {
                    return entry[1] === this.intent.Status;
                })[0];
            }

            return '';
        },
    },
};
</script>
